
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("kZbWI"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("kZbWI", function(module, exports) {

let $f472c55d74a427c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f472c55d74a427c4$var$load("h3ABO"),
    $f472c55d74a427c4$var$load("a2Wil"),
    $f472c55d74a427c4$var$load("aNhGE"),
    $f472c55d74a427c4$var$load("djHM5"),
    $f472c55d74a427c4$var$load("eJQji"),
    $f472c55d74a427c4$var$load("2YffH"),
    $f472c55d74a427c4$var$load("9slUK"),
    $f472c55d74a427c4$var$load("6mHrv"),
    $f472c55d74a427c4$var$load("awWN9"),
    $f472c55d74a427c4$var$load("9CYct"),
    $f472c55d74a427c4$var$load("9QUT8"),
    $f472c55d74a427c4$var$load("5zRul"),
    $f472c55d74a427c4$var$load("hZtKG"),
    $f472c55d74a427c4$var$load("dkqvW"),
    $f472c55d74a427c4$var$load("lVO3w"),
    $f472c55d74a427c4$var$load("hyzoX"),
    $f472c55d74a427c4$var$load("h9Ed7"),
    $f472c55d74a427c4$var$load("eBRUf"),
    $f472c55d74a427c4$var$load("kbRvk"),
    $f472c55d74a427c4$var$load("9Vh0G"),
    $f472c55d74a427c4$var$load("hBIgN"),
    $f472c55d74a427c4$var$load("cD6Zr"),
    $f472c55d74a427c4$var$load("9wzNh"),
    $f472c55d74a427c4$var$load("8YSo7"),
    $f472c55d74a427c4$var$load("3Zfzp"),
    $f472c55d74a427c4$var$load("9ldRJ"),
    $f472c55d74a427c4$var$load("50ame"),
    $f472c55d74a427c4$var$load("eYWAR"),
    $f472c55d74a427c4$var$load("8z2kq"),
    $f472c55d74a427c4$var$load("ebWFc"),
    $f472c55d74a427c4$var$load("6iz6l"),
    $f472c55d74a427c4$var$load("4SCW2"),
    $f472c55d74a427c4$var$load("8bXcu"),
    $f472c55d74a427c4$var$load("1YiFu"),
    $f472c55d74a427c4$var$load("hv4mn"),
    $f472c55d74a427c4$var$load("Wowvf"),
    $f472c55d74a427c4$var$load("dek7I"),
    $f472c55d74a427c4$var$load("3SmkN"),
    $f472c55d74a427c4$var$load("dYtBN"),
    $f472c55d74a427c4$var$load("kNV5Y"),
    $f472c55d74a427c4$var$load("6wr18"),
    $f472c55d74a427c4$var$load("kjZZD"),
    $f472c55d74a427c4$var$load("2zxmz"),
    $f472c55d74a427c4$var$load("7269o"),
    $f472c55d74a427c4$var$load("3JSgG"),
    $f472c55d74a427c4$var$load("37ldp"),
    $f472c55d74a427c4$var$load("ffEVr"),
    $f472c55d74a427c4$var$load("dRpV3"),
    $f472c55d74a427c4$var$load("28arV"),
    $f472c55d74a427c4$var$load("hhss7"),
    $f472c55d74a427c4$var$load("jYUNl"),
    $f472c55d74a427c4$var$load("foy8I"),
    $f472c55d74a427c4$var$load("jY21r"),
    $f472c55d74a427c4$var$load("dP7ao"),
    $f472c55d74a427c4$var$load("hogcU"),
    $f472c55d74a427c4$var$load("i8eeg"),
    $f472c55d74a427c4$var$load("iFdoJ"),
    $f472c55d74a427c4$var$load("7EorR"),
    $f472c55d74a427c4$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.438aff5b.js.map
